import { render } from "./imageText.vue?vue&type=template&id=5986b925&scoped=true"
import script from "./imageText.vue?vue&type=script&lang=js"
export * from "./imageText.vue?vue&type=script&lang=js"

import "./imageText.vue?vue&type=style&index=0&id=5986b925&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5986b925"

export default script